module.exports = __webpack_public_path__ + "static/media/shirt-cooperate-4.464aa9ef.jpg";